import { render, staticRenderFns } from "./EmployeeWorkforceHistory.vue?vue&type=template&id=4d981860&scoped=true&"
import script from "./EmployeeWorkforceHistory.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceHistory.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceHistory.vue?vue&type=style&index=0&id=4d981860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d981860",
  null
  
)

export default component.exports